module.exports = __webpack_public_path__ + "img/PL08863.4b8d14b1.png";